/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  const domain = window.location.hostname
  const swHost = domain === 'parcari-s4.verdedata.ro' ? process.env.BASE_URL : 'https://parcari-s4.verdedata.ro/'

  register(`${swHost}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('register worker installing')
      console.log('New content is available; please refresh. Service worker should do that by itself')
      let worker = registration.waiting
      worker.postMessage({ action: 'skipWaiting' })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

var refreshing
navigator.serviceWorker.addEventListener('controllerchange', function () {
  if (refreshing) return
  window.location.reload()
  refreshing = true
})
